import { render, staticRenderFns } from "./LCol.vue?vue&type=template&id=9f67849a"
import script from "./LCol.vue?vue&type=script&lang=js"
export * from "./LCol.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports